// Kleine Einstellungen pro Browser (localStorage), z. B. Engine an/aus oder die gewählte Spielstärke.
export function loadPref<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem(`schachserver.${key}`);
    return v === null ? fallback : (JSON.parse(v) as T);
  } catch {
    return fallback;
  }
}

export function savePref(key: string, v: unknown) {
  try {
    localStorage.setItem(`schachserver.${key}`, JSON.stringify(v));
  } catch {
    // ohne Speicher gilt die Wahl nur bis zum Neuladen
  }
}
